<template>
    <div class="page-info-section set-bg" :style="{'background-image': 'url('+image+')'}" :class="{'lesson': $route.name == 'leccion'}">
		<div class="ml-5 mr-5 d-flex">
			<div class="site-breadcrumb d-none d-md-block">
				<router-link to="/">Inicio</router-link>
                <slot></slot>
			</div>
		</div>
	</div>
</template>

<script>
export default {
    name: 'breadcrumbs',
    data() {
        return {
            image: 'https://www.justcompileit.com/videos/cursos-streaming/images/breadcrumbs.jpg'    
        }
    } 
}
</script>

<style lang="scss" scoped>
    @import '@/variables.scss';

    .page-info-section {
        height: 160px;
        @media (max-width: 767px) {
            height: 100px;
        }
        &.lesson {
            height: 275px !important;
        }
        .site-breadcrumb {
            a {
                margin-right: 20px;
                &:hover {
                    color: $main-color;
                    text-decoration: none;
                }
            }
            span {
                color: $main-color;
            }
        }
    }
</style>


